export default __webpack_public_path__ + "static/media/character_win_3.ce6181ea.mp3";